import React from "react";
import { FormStepsProps } from "../FormStepsProps";
import ReportDetailsCheckboxs from "./ReportDetailsCheckboxs";
import ReportDetailsInputs from "./ReportDetailsInputs";

const DetailsFormSection = ({
  control,
  errors,
  setSelectedPolicy,
  setValue,
  canvasImages,
  setCanvasImages,
  currentCroppedButton,
  setCurrentCroppedButton,
  addCroppedImageArray,
  setAddCroppedImageArray,
  getValues,
  isAlreadyDuplicated,
  reportIsDuplicate,
}: FormStepsProps) => {
  return (
    <div className="DetailsFormSection-container">
      <ReportDetailsInputs
        control={control}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        isAlreadyDuplicated={isAlreadyDuplicated}
      />
      <ReportDetailsCheckboxs
        control={control}
        errors={errors}
        setSelectedPolicy={setSelectedPolicy}
        setValue={setValue}
        canvasImages={canvasImages}
        setCanvasImages={setCanvasImages}
        addCroppedImageArray={addCroppedImageArray}
        setAddCroppedImageArray={setAddCroppedImageArray}
        currentCroppedButton={currentCroppedButton}
        setCurrentCroppedButton={setCurrentCroppedButton}
        getValues={getValues}
        reportIsDuplicate={reportIsDuplicate}
      />
    </div>
  );
};
export default DetailsFormSection;
